import { FormConfig } from "../../../shared/types/legacy";

export const formQ: FormConfig = {
    name: {
        type: 'text',
        label: '',
        nombreService: 'name',
        value: '',
        validators: ['required'],
        autocomplete: 'off',
        readonly: true,
        options: [],
        hidden: false,
        disabled: false
    },
    username: {
        type: 'text',
        label: '',
        nombreService: 'username',
        value: '',
        validators: ['required'],
        autocomplete: 'off',
        readonly: true,
        options: null,
        hidden: false,
        disabled: false
    },
    email: {
        type: 'text',
        label: '',
        nombreService: 'email',
        value: '',
        validators: ['required', 'email'],
        autocomplete: 'off',
        readonly: false,
        options: null,
        hidden: false,
        disabled: false
    },
    phone: {
        type: 'int',
        label: '',
        nombreService: 'phone',
        value: '',
        validators: [],
        autocomplete: 'off',
        readonly: false,
        options: null,
        hidden: false,
        disabled: false
    },
    password: {
        type: 'password',
        label: '',
        nombreService: 'password',
        value: '',
        validators: ['required', 'repeat'],
        autocomplete: 'new-password',
        readonly: false,
        options: [],
        hidden: false,
        disabled: false
    },
    passwordRepeat: {
        type: 'password',
        label: '',
        nombreService: 'passwordRepeat',
        value: '',
        validators: ['required', 'repeat'],
        autocomplete: 'new-password',
        readonly: false,
        options: [],
        hidden: false,
        disabled: false
    },
    certinfo: {
        type: 'text',
        label: '',
        nombreService: 'certinfo',
        value: '',
        validators: ['required'],
        autocomplete: 'off',
        readonly: false,
        options: null,
        hidden: true,
        disabled: true
    }
}
